import React, { FC } from "react";

import { ArrowRightIcon } from "application/assets";

import { BannerProps } from "./models";
import { Wrapper } from "./styles";

const ReferralBonusBanner: FC<BannerProps> = ({ onClick }) => {
  return (
    <Wrapper>
      <p>Invest in this deal and get your referral bonus!</p>
      <button type="button" onClick={onClick}>
        <ArrowRightIcon />
      </button>
    </Wrapper>
  );
};

export default ReferralBonusBanner;
